import Vue from 'vue'
import Router from 'vue-router'
import * as dd from 'dingtalk-jsapi';

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'index',
    component:()=>import('@/views/index'),
    meta:{
      title:"中富金石-首页"
    }
  },
  {
    path: '/introduction',
    name: 'introduction',
    component:()=>import('@/views/Introduction'),
    meta:{
      title:"中富金石-企业简介"
    }
  },
  {
    path: '/news',
    name: 'news',
    component:()=>import('@/views/news'),
    meta:{
      title:"中富金石-企业动态"
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component:()=>import('@/views/contact'),
    meta:{
      title:"中富金石-联系我们"
    }
  },
  {
    path: '/protect',
    name: 'protect',
    component:()=>import('@/views/protect'),
    meta:{
      title:"中富金石-投资者保护"
    }
  },
  {
    path: '/download',
    name: 'download',
    component:()=>import('@/views/download'),
    meta:{
      title:"中富金石-终端下载"
    }
  },
  {
    path: '/staff',
    name: 'people',
    component:()=>import('@/views/people'),
    meta:{
      title:"中富金石-从业人员资质"
    }
  },
  {
    path: '/firm',
    name: 'firm',
    component:()=>import('@/views/firm'),
    meta:{
      title:"中富金石-企业资质证明"
    }
  },
  {
    path: '/Product',
    name: 'Product',
    component:()=>import('@/views/Product'),
    meta:{
      title:"中富金石-产品中心"
    }
  },
  {
    path: '/article/:id(\\d+)',
    name: 'detail',
    component:()=>import('@/views/detail'),
    meta:{
      title:"中富金石-正文"
    }
  },
  {
    path: '/s/:id(.+)',
    name: 'detail',
    component:()=>import('@/views/detail1'),
    meta:{
      title:"中富金石-正文"
    }
  },
  {
    path: '*', // 页面不存在的情况下会跳到首页
    redirect: '/',
    name: 'notFound',
    hidden: true
    }
]


const router = new Router({
  mode:'history',
  routes,
  scrollBehavior(to,from,savedPosition){
    return {x:0,y:0}
  }
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
    if (dd.env.platform!=="notInDingTalk") {
      //钉钉设置title
      dd.ready(() => {
          dd.biz.navigation.setTitle({
            title: to.meta.title,
          })
      })
  }
  }
// 统计代码
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})

export {
  router
}



// WEBPACK FOOTER //
// ./src/router/index.js